// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__5fzSj","text":"Hero_text___neoP","ribbon":"Hero_ribbon__30yHh","cta":"Hero_cta__xrYTZ"};